<mat-card class="sideCard px-sm-0 p-lg-3">
    <mat-card-content>
        <span class="sideTitle mx-4"> {{ 'SIDE_MENU.LABEL1' | translate }} </span>
        <mat-divider class="my-2" inset></mat-divider>
        <a href="https://masgarantia.liverpool.com.mx/" class="sideItem mx-4"> {{ 'SIDE_MENU.LABEL2' | translate }} </a>
    </mat-card-content>
</mat-card>